module.exports = __webpack_public_path__ + "img/stick_activites_bien_etre.406e9360.svg";